import { render, staticRenderFns } from "./ReportNatPat.vue?vue&type=template&id=090a3c38&scoped=true"
import script from "./ReportNatPat.vue?vue&type=script&lang=js"
export * from "./ReportNatPat.vue?vue&type=script&lang=js"
import style0 from "./ReportNatPat.vue?vue&type=style&index=0&id=090a3c38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090a3c38",
  null
  
)

export default component.exports